<template>
  <div v-loading="processing" class="medication-list-item" :class="{'medication-list-item__has_dispense': hasDispense}">
    <div class="medication-list-item__header">
      <label class="medication-list-item__title" :for="`select-medication-${medication.id}`">
        <input
          v-if="isMedicationDispense && !wasSent"
          :id="`select-medication-${medication.id}`"
          type="checkbox"
          :checked="selected"
          @input="$emit('select', medication.id)">
        <h4 class="medication-list-item__name">{{ medication.data.medicationReference.display }}</h4>
      </label>
      <div class="d-flex">
        <div v-if="hasMedicationDispenses">
          Dispensaciones previas: <span class="medication-list-item__has_dispense_quantity">{{ medication.medicationDispenses.length }}</span> <a href="#" @click.prevent="handleClickShowPreviousDispenses">Ver Detalle</a>
        </div>
        <div class="ml-3">
          <!-- <span>{{ medication.created_at | date }}</span> -->
        </div>
      </div>
    </div>
    <hr>
    <dl class="medication-list-item__body">
      <template v-if="isMedicationRequest">
        <dd />
        <dd />
        <dd class="l-peq mb-0">
          Administrar <span v-if="dispenseQuantity > 0">{{dispenseQuantity}} ({{numeroALetras(dispenseQuantity)}}) {{dispenseQuantity > 1 ? 'unidades' : 'unidad'}}</span>
        </dd>
        <dd>
          <table class="l-peq" style="width:100%;">
            <tbody>
              <tr>
                <td><strong>Dosis</strong></td>
                <td><strong>Frecuencia</strong></td>
                <td><strong>Vía de administración</strong></td>
                <td><strong>Periodo de Tratamiento</strong></td>
              </tr>
              <tr>
                <td>
                  {{ getDosis }}
                </td>
                <td>
                  cada {{ getFrecuencia }}
                </td>
                <td>{{ getVia }}</td>
                <td>por {{ getPeriod }}</td>
              </tr>
            </tbody>
          </table>
        </dd>
      </template>
      <template v-if="isMedicationDispense">
        <dt>Cantidad</dt>
        <dd>{{ quantitySummary }}</dd>
      </template>
      <template v-if="isSubstitution">
        <dt>Razón del cambio de medicamento</dt>
        <dd>{{ medication.data.substitution.reason }}</dd>
      </template>
      <!-- <template v-if="hasMedicationDispenses">
        <div class="alert alert-warning">
          <dt>Dispensaciones anteriores</dt>
          <dd>
            Este medicamento se ha dispensado <strong>{{ medication.medicationDispenses.length }}</strong> veces.
            <a href="#" @click.prevent="handleClickShowPreviousDispenses">Ver Detalle</a>
          </dd>
        </div>
      </template> -->
    </dl>
    <div class="medication-list-item__footer">
      <button
        v-if="isMedicationRequest && !isCancelled && enableRecipe && !hasDispense"
        class="btn btn-danger btn-block"
        typeof="button"
        @click.prevent="handleClickDispenseButton">
        Dispensar
      </button>
      <template v-if="hasDispense">
        <button
          class="btn btn-success btn-block"
          typeof="button">
          Seleccionado ({{ medicationDispenseQuantity }}) <i class="fas fa-check ml-2" />
        </button>
        <div class="d-flex justify-content-around">
          <button type="button" class="btn btn-link" @click.prevent="handleClickDispenseDeleteButton">
            Eliminar <i class="fas fa-trash-alt ml-2" />
          </button>
          <button type="button" class="btn btn-link" @click.prevent="handleClickDispenseEditButton">
            Modificar <i class="fas fa-edit ml-2" />
          </button>
        </div>
      </template>

      <template v-if="isMedicationDispense">
        <button
          v-if="!wasSent"
          class="btn btn-outline-info btn-block"
          typeof="button"
          @click.prevent="handleClickDispenseButton">
          Ver Detalles
        </button>
        <div v-else class="alert alert-success">
          Medicamento Dispensado
        </div>
      </template>
      <div v-if="isCancelled" class="alert alert-danger">
        Este receta ha sido anulada
      </div>
      <dd v-if="existDispenses">
        <p v-if="fetchingRefSets" v-loading="fetchingRefSets">Verificando si se puede redispensar el medicamento. Espere...</p>
        <p v-else>
          <span v-if="retainPrescription">El medicamento posee control de existencia y por lo tanto, no puede volver a ser dispensado.</span>
        </p>
      </dd>
    </div>
    <i v-if="hasErrors" title="Ha ocurrido un error al enviar la dispensación" class="medication-list-item__error-icon fas fa-exclamation-circle" />
  </div>
</template>

<script>
import _get from 'lodash/get';
import numeroALetras from '@/helpers/numeroLetras';

export default {
  name: 'MedicationListItem',
  props: {
    medication: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'medication-request'
    },
    selected: {
      type: Boolean,
      default: false
    },
    processing: {
      type: Boolean,
      default: false
    },
    retainPrescription: {
      type: Boolean,
      default: false
    },
    existDispenses: {
      type: Boolean,
      default: false
    },
    fetchingRefSets: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dispenseQuantity(){
      try {
        return parseInt(this.medication.data.dispenseRequest.quantity);
      } catch (e){
        return 0;
      }
    },
    hasDispense() {
      return (this.medication.dispense);
    },
    medicationDispense() {
      return (this.hasDispense) ? this.medication.dispense : null;
    },
    medicationDispenseQuantity() {
      return this.medicationDispense.data.quantity.value;
    },
    getDosis() {
      const doseQuantity = _get(this.medication, 'data.dosageInstruction[0].doseAndRate[0].doseQuantity');
      return this.pluralDoseQuantity(doseQuantity.value, doseQuantity.unit);
    },
    getFrecuencia() {
      const doseTiming = _get(this.medication, 'data.dosageInstruction[0].timing.repeat');
      return this.formatPlural(doseTiming.period, doseTiming.periodUnit);
    },
    getVia() {
      const route = _get(this.medication, 'data.dosageInstruction[0].route.coding[0].display');
      return route;
    },
    getPeriod() {
      const period = _get(this.medication, 'data.dosageInstruction[0].timing.repeat.boundsDuration');
      return this.formatPlural(period.value, period.code);
    },
    wasSent() {
      return this.medication.hasOwnProperty('status') && this.medication.status === 'success';
    },
    hasErrors() {
      return this.medication.hasOwnProperty('status') && this.medication.status === 'error';
    },
    isMedicationRequest() {
      return this.type === 'medication-request';
    },
    isMedicationDispense() {
      return this.type === 'medication-dispense';
    },
    hasMedicationDispenses() {
      return this.medication.hasOwnProperty('medicationDispenses') && this.medication.medicationDispenses.length;
    },
    doseSummary() {
      const doseQuantity = _get(this.medication, 'data.dosageInstruction[0].doseAndRate[0].doseQuantity');
      const doseTiming = _get(this.medication, 'data.dosageInstruction[0].timing.repeat');
      const route = _get(this.medication, 'data.dosageInstruction[0].route.coding[0].display');
      return `${doseQuantity.value} ${doseQuantity.unit} / ${this.formatPlural(doseTiming.frequency, doseTiming.periodUnit)} / ${route}`;
    },
    quantitySummary() {
      const quantityValue = _get(this.medication, 'data.quantity.value');
      const quantityCode = _get(this.medication, 'data.quantity.code');
      return `${quantityValue} - ${quantityCode}`;
    },
    isSubstitution() {
      return this.type === 'medication-dispense' && this.medication.data.substitution.wasSubstituted;
    },
    isCancelled() {
      return this.medication.status === 'cancelled';
    },
    enableRecipe() {
      return (!this.fetchingRefSets && this.existDispenses && !this.retainPrescription) || !this.existDispenses;
    }
  },
  methods: {
    numeroALetras : numeroALetras,
    pluralDoseQuantity(doseQuantity, doseValue) {
      let pluralValue = doseValue;
      if (doseQuantity > 1) {
        switch (doseValue) {
          case 'anillo vaginal': pluralValue = 'anillos vaginales'; break;
          case 'cápsula vaginal': pluralValue = 'cápsulas vaginales'; break;
          case 'jeringa prellenada': pluralValue = 'jeringas prellenadas'; break;
          case 'aplicación': pluralValue = 'aplicaciones'; break;
          case 'bidón': pluralValue = 'bidones'; break;
          case 'dosis': pluralValue = 'dosis'; break;
          case 'gotas': pluralValue = 'gotas'; break;
          case 'matraz': pluralValue = 'matraces'; break;
          case 'unidades internacionales': pluralValue = 'unidades internacionales'; break;
          case 'unidades': pluralValue = 'unidades'; break;
          case 'vial': pluralValue = 'viales'; break;
          default: pluralValue = `${doseValue}s`;
        }
      }

      return `${doseQuantity} ${pluralValue}`;
    },
    getUnitOfTimeDisplay(periodUnit) {
      return this.$store.getters.unitsOfTime.find(u => u.code === periodUnit).display;
    },
    handleClickDispenseButton() {
      this.$emit('medication-dispense', this.medication);
    },
    handleClickDispenseEditButton() {
      this.$emit('medication-dispense-edit', this.medication);
    },
    handleClickDispenseDeleteButton() {
      this.$emit('medication-dispense-delete', this.medication);
    },
    handleClickShowPreviousDispenses() {
      this.$emit('show-previous-dispenses', this.medication);
    },
    formatPlural(value, period, quitA = false) {
      let timing = value > 1 ? {
        'h': 'horas',
        'd': 'días',
        's': 'segundos',
        'min': 'minutos',
        'wk': 'semanas',
        'm': 'meses',
        'mo': 'meses',
        'a': 'años'
      } : {
        'h': 'hora',
        'd': 'día',
        's': 'segundo',
        'min': 'minuto',
        'wk': 'semana',
        'm': 'mes',
        'mo': 'mes',
        'a': 'año'
      };

      return value + ' ' + (timing[period] ? timing[period] : period);

      /*
      let conector;
      switch (period) {
        case 'h':
        case 'min':
        case 's':
          conector = quitA ? '' : 'a la';
          return `${value} ${conector} ${this.getUnitOfTimeDisplay(period)}${value != '1' ? 's' : ''}`;
        case 'd':
          conector = quitA ? '' :  (value != '1' ? 'a los' : 'al');
          return `${value} ${conector} ${this.getUnitOfTimeDisplay(period)}${value != '1' ? 's' : ''}`;
        case 'wk':
          return `${value} ${this.getUnitOfTimeDisplay(period)}${value != '1' ? 's' : ''}`;
        case 'mo':
          conector = quitA ? '' : 'al';
          return `${value} ${conector} ${this.getUnitOfTimeDisplay(period)}${value != '1' ? 'es' : ''}`;
         case 'a':
          conector = quitA ? '' : 'al';
          return `${value} ${conector} ${this.getUnitOfTimeDisplay(period)}${value != '1' ? 's' : ''}`;
        default:
          conector = quitA ? '' : 'al';
          return `${value} ${conector} ${this.getUnitOfTimeDisplay(period)}`;
      }
      */
    }
  }
};
</script>

<style lang="scss">

.l-peq {
  font-size: small;
}

.medication-list-item {
  position: relative;
  padding: $--spacing-4;
  border: 1px solid $--color-light-gray;
  border-radius: $--border-radius-base;
  &__name{
    margin-bottom: 10px;
  }

  &__title {
    display: flex;
    margin-bottom: 0;

    input[type="checkbox"] {
      margin-right: 5px;
    }

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  &__error-icon {
    position: absolute;
    right: $--spacing-4;
    top: $--spacing-4;
    color: $--color-red;
  }

  &__has_dispense{
    background-color: #F1F4F8;
    &_quantity{
      background-color: #CFD5DD;
      font-weight: bold;
      display: inline-block;
      border-radius: 2px;
      margin: 0 5px;
      padding: 2px 5px;
    }
  }
}
</style>
